/* ------------------------------------------------------------------
   Threedium popup controller – event delegation edition
   Listens on document so it works even if FoxTheme re-renders the
   product section after DOMContentLoaded.
   ------------------------------------------------------------------ */

/* Open popup */
document.addEventListener('click', function (e) {
    const button = e.target.closest('.threedium-init');
    if (!button) return;

    const popupId = button.getAttribute('data-popup');
    const popup = document.querySelector(`.threedium-popup[data-popup="${popupId}"]`);

    if (popup) {
        popup.classList.add('active');

        // Lazy-load: only set src when the popup is opened so WebGL
        // doesn't initialise on page load and crash mobile browsers.
        const iframe = popup.querySelector('.threedium-iframe');
        if (iframe && !iframe.getAttribute('src') && iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
        }

        document.body.style.overflow = 'hidden';
    }
});

/* Close button inside popup */
document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.threedium-popup-close');
    if (!closeBtn) return;

    const popup = closeBtn.closest('.threedium-popup');
    if (popup) {
        popup.classList.remove('active');
        document.body.style.overflow = '';

        // Unload the iframe to free the WebGL context from memory.
        const iframe = popup.querySelector('.threedium-iframe');
        if (iframe) {
            iframe.removeAttribute('src');
        }
    }
});

/* ESC key closes all active popups */
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        document.querySelectorAll('.threedium-popup.active').forEach(function (popup) {
            popup.classList.remove('active');
        });
        document.body.style.overflow = '';
    }
});

/* ------------------------------------------------------------------
   Viewport-height custom property (fixes 100vh on mobile Safari)
   ------------------------------------------------------------------ */
function setVh() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
}

setVh();
window.addEventListener('resize', setVh);
window.addEventListener('orientationchange', setVh);
